import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthClientConfig, AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { USER_MANAGEMENT_API_BASE_URL } from '@cloudmed/user-management-api-client';
import { environment } from '@env/environment';
import { Idle, IdleExpiry } from '@ng-idle/core';
import {
  APP_INSIGHTS_CONFIG,
  ApplicationInsightsService,
  ConfirmationService,
  CookieExpiry,
  IDLE_CONFIG,
  IdleConfig,
  PagesModule,
} from '@r1-development/rps-shared-ui';
import { RULE_MANAGEMENT_API_BASE_URL } from '@r1-development/rule-management-api-client';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CmaiHttpInterceptor } from './shared';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, FormsModule, SharedModule, PagesModule, AuthModule.forRoot(), AppRoutingModule],
  providers: [
    provideAnimations(),
    provideZoneChangeDetection(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CmaiHttpInterceptor,
      multi: true,
    },
    {
      provide: USER_MANAGEMENT_API_BASE_URL,
      useValue: environment.api.userManagementBaseUrl,
    },
    {
      provide: APP_INSIGHTS_CONFIG,
      useValue: { instrumentationKey: environment.appInsights.instrumentationKey },
    },
    {
      provide: RULE_MANAGEMENT_API_BASE_URL,
      useValue: environment.api.ruleManagementServiceBaseURL,
    },
    { provide: IdleExpiry, useExisting: CookieExpiry },
    CookieExpiry,
    Idle,
    // Idle Timeout Configuration
    {
      provide: IDLE_CONFIG,
      useValue: {
        secondsBeforeModal: 1800,
        secondsBeforeTimeout: 120,
      } as IdleConfig,
    },
    ConfirmationService,
    MatSnackBar,
    ApplicationInsightsService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private readonly authConfig: AuthClientConfig) {
    this.authConfig.set({
      clientId: environment.auth0Config.clientId,
      domain: environment.auth0Config.domain,
      authorizationParams: {
        audience: environment.auth0Config.audience,
        // eslint-disable-next-line camelcase
        redirect_uri: window.location.origin + '/callback',
        useRefreshTokens: environment.auth0Config.useRefreshTokens,
        useRefreshTokensFallback: environment.auth0Config.useRefreshTokensFallback,
      },
      httpInterceptor: {
        allowedList: [...environment.revenueIntelligenceBaseUrls.map((url) => `${environment.api[url]}*`)],
      },
    });
  }
}
